import { Capacitor } from '@capacitor/core';
import { currentUser, isLoggedIn } from './authentication';
import { initCleverTap } from './clevertapService';

export const onUserLogin = () => {
  if (currentUser()?.id) {
    if (Capacitor.isNativePlatform()) {
      window.CleverTap.onUserLogin({
        Identity: String(currentUser().id),
      });
    } else {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          clevertap.onUserLogin.push({
            Site: {
              Identity: String(currentUser().id),
            },
          });
        }
      });
    }
    console.warn('CleverTap user ID set:', currentUser().id);
  }
};

export const pushEvent = (eventName: string) => {
  if (Capacitor.isNativePlatform()) {
    window.CleverTap.recordEventWithName(eventName);
  } else {
    if (isLoggedIn()) {
      initCleverTap().then((clevertap) => {
        if (clevertap) {
          clevertap.event.push(eventName);
        }
      });
    }
  }
  console.warn('CleverTap event pushed:', eventName);
};
